'use strict';

var currency = require('./types/currency.cjs');
var index = require('./utils/index.cjs');
var index$1 = require('./constants/index.cjs');
var trans = require('./utils/trans.cjs');
var localized = require('./utils/localized.cjs');
var currency$1 = require('./utils/currency.cjs');



exports.CurrencyCode = currency.CurrencyCode;
exports.CurrencySymbol = currency.CurrencySymbol;
exports.isValidLocale = index.isValidLocale;
exports.COOKIE_KEY_LOCALE = index$1.COOKIE_KEY_LOCALE;
exports.DEFAULT_LOCALE = index$1.DEFAULT_LOCALE;
exports.HEADER_KEY_LOCALE = index$1.HEADER_KEY_LOCALE;
exports.i18nConfig = index$1.i18nConfig;
exports.locales = index$1.locales;
exports.TODO_trans = trans.TODO_trans;
exports.notrans = trans.notrans;
exports.trans = trans.trans;
exports.TODO_localized = localized.TODO_localized;
exports.localized = localized.localized;
exports.getCurrencyLabelI18nKey = currency$1.getCurrencyLabelI18nKey;
exports.getCurrencySymbol = currency$1.getCurrencySymbol;
//# sourceMappingURL=index.cjs.map
